module.exports = __webpack_public_path__ + "static/media/NORAD-logo.eee04aa8.png";